document.addEventListener('DOMContentLoaded', function () {
  const carousels = document.querySelectorAll('main-product-carousel');

  carousels.forEach(carousel => {
    const container = carousel.querySelector('.carousel--container');
    if (!container) return;

    const slides = Array.from(container.querySelectorAll('.carousel--block'));
    if (slides.length < 2) return;

    const slideWidth = slides[0].offsetWidth;
    const scrollAmount = slideWidth;

    const nextBtn = carousel.querySelector('.carousel--next');
    const prevBtn = carousel.querySelector('.carousel--prev');

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }
  });
});
